module.exports = __webpack_public_path__ + "img/inge-v6-4.aeeb5fd3.png";